import { render, staticRenderFns } from "./ChartsPanel.vue?vue&type=template&id=24985ec5&scoped=true"
import script from "./ChartsPanel.vue?vue&type=script&lang=js"
export * from "./ChartsPanel.vue?vue&type=script&lang=js"
import style0 from "./ChartsPanel.vue?vue&type=style&index=0&id=24985ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24985ec5",
  null
  
)

export default component.exports